module.exports = __webpack_public_path__ + "img/webCode.f8428610.png";